"use client";
import type { ReactNode } from "react";
import { setShallowSearchParams, useShallowSearchParam } from "@/lib/hooks/use-shallow-search-param";

export type SailingCategory = "club" | "hp" | "compare";
export function useSailingCategory(): SailingCategory {
  const value = useShallowSearchParam("boat");
  return value === "hp" || value === "compare" ? value : "club";
}
export function SailingCategoryControl() {
  const category = useSailingCategory();
  return <label className="flex min-h-11 items-center gap-3 text-[12px] font-semibold text-text-muted">Boat
    <select aria-label="Choose sailing category" value={category} onChange={(event) => setShallowSearchParams({ boat: event.target.value })} className="min-h-11 min-w-0 flex-1 rounded-[10px] border border-border bg-white px-3 text-[14px] font-bold text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal md:max-w-[320px]">
      <option value="club">Club Dinghy</option><option value="hp">High Performance</option><option value="compare">Compare both categories</option>
    </select>
  </label>;
}
export function SailingCategoryView({ category, children, fallback }: { category: "club" | "hp"; children: ReactNode; fallback?: ReactNode }) {
  const active = useSailingCategory();
  return active === category || active === "compare" ? children : fallback ?? null;
}
